import { useState } from 'react';
import { Input } from '../../../components/Form/Input';
import { Button } from '../../../components/Form/Button';
import { handleCreateEmailUser } from '../authActions';
import { PasswordInput } from './PasswordInput';
import { useNavigate } from 'react-router-dom';

interface FormElements extends HTMLFormControlsCollection {
  email: HTMLInputElement;
  password: HTMLInputElement;
}

interface LoginFormElement extends HTMLFormElement {
  readonly elements: FormElements;
}

export const SignupForm: React.FC = () => {
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent<LoginFormElement>) => {
    e.preventDefault();

    const formData = new FormData(e.currentTarget);
    const email = formData.get('email') as string;
    const password = formData.get('password') as string;
    const confirmPassword = formData.get('confirm-password') as string;

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    const response = await handleCreateEmailUser(email, password);

    if (response === 'success') {
      navigate('/v1/create-profile');
    } else if (response === 'error') {
      setError('Error creating account. Please try again.');
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-5">
      {error && (
        <p className="text-red-500 text-xs text-center mb-4">{error}</p>
      )}
      <Input
        name="email"
        label="Email"
        type="email"
        placeholder="Email"
        className="w-full"
        required
      />
      <PasswordInput />
      <Input
        name="confirm-password"
        label="Confirm Password"
        type="password"
        placeholder="Password"
        className="w-full"
        required
      />
      <div className="flex space-x-4">
        <Button type="submit" variant="primary" className="w-full py-2 text">
          <span className="text-sm">Create Account</span>
        </Button>
      </div>
    </form>
  );
};
